var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.917 52.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".p-cls-1{fill:#444;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3226 0 0 1.6282 5.3 .40618)",
    strokeWidth: 0,
    "data-name": "Layer 42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p-cls-1",
    d: "m2 29a1 1 0 0 1-1-1.11l0.77-7a1 1 0 0 1 0.29-0.59l16.36-16.36a3.2 3.2 0 0 1 4.53 0l3.11 3.11a3.2 3.2 0 0 1 0 4.53l-16.35 16.35a1 1 0 0 1-0.59 0.29l-7 0.77zm7-1.78m-5.27-5.77-0.6 5.42 5.42-0.6 16.1-16.1a1.2 1.2 0 0 0 0-1.7l-3.12-3.12a1.2 1.2 0 0 0-1.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-cls-1",
    d: "m23 14.21a1 1 0 0 1-0.71-0.29l-6.21-6.23a1.0041 1.0041 0 0 1 1.42-1.42l6.23 6.23a1 1 0 0 1 0 1.42 1 1 0 0 1-0.73 0.29z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p-cls-1",
    transform: "rotate(-45 12.901 17.096)",
    x: 7.39,
    y: 16.1,
    width: 11.01,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-cls-1",
    d: "m30 29h-16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.055444f144835232bfd8b8545cb60401.svg";
export { ForwardRef as ReactComponent };